import {
  DeleteOutlined,
  InfoCircleOutlined,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Input,
  Menu,
  Pagination,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
  message,
} from 'antd';
import dayjs from 'dayjs';
import 'jspdf-autotable';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import { ReactComponent as PrintIcon } from '../../Images/SimplePrintIcon.svg';
import { deleteCustomer } from '../../slices/customer';
import { fetchstocReportList } from '../../slices/stock-verify';

function StockVerificationList() {
  let navigate = useNavigate();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]); // Track
  const { user: currentUser } = useSelector(state => state.auth);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dispatch = useDispatch();
  const { Reportdata = [], ReporttotalRecord, status } = useSelector(state => state.stockverify);
  const [search, setSearch] = useState(localStorage.getItem('stockVerificationList') || '');
  const [inputValue, setInputValue] = useState(localStorage.getItem('stockVerificationList') || '');
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(20);

  const [checkedList, setCheckedList] = useState([
    'report_id',
    'date_time',
    'action',
  ]);

  const handleColumnVisibilityChange = checkedValues => {
    setCheckedList(checkedValues);
  };

  const handleEdit = data => {


    navigate(`/edit-report/${data.report_id}`);
  };

  const handlePrint = data => {


    navigate(`/print/stock-verification/${data.report_id}`);
  };
  const handleDelete = id => {
    if (!id) {
      message.error('Missing ID for deletion!');
      return;
    }

    dispatch(deleteCustomer(id))
      .unwrap()
      .then(() => {
        message.success('Customer Archive Successfully!');
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error); // Handle string error
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };
  const columns = [
    {
      title: 'Report No.',
      dataIndex: 'report_id', // Use a unique key for the serial number
      key: 'report_id',
      width: "40px",

    },
    {
      title: 'Date & Time',
      dataIndex: 'date_time',
      key: 'date_time',
      width: "100px",
      sorter: true,

      render: record => {
        return (
          <span>
            {record && record.trim()
              ? dayjs(record).format('DD-MM-YYYY HH:mm')
              : 'N/A'}
          </span>
        );
      },
    },

    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      width: "100px",
      fixed: 'right',

      render: (_, record) => (
        <Space size="middle">
          
                {currentUser.permissions.permissions.bundle_verification.includes(
                  'change_stockverification',
                ) && (
          <Tooltip placement="top" title={'Edit Stock Report'}>
            <InfoCircleOutlined style={{ fontSize: '18px', color: '#faad14', cursor: 'pointer' }} onClick={() => handleEdit(record)} />
          </Tooltip>)}
           {currentUser.permissions.permissions.bundle_verification.includes(
                  'print_stock_verification_copy',
                ) && (
          <Tooltip placement="top" title={'Print'}>
            <span onClick={() => handlePrint(record)}>
              <PrintIcon style={{ fontSize: '18px', cursor: 'pointer' }} />
            </span>
          </Tooltip>
                )}
           {currentUser.permissions.permissions.bundle_verification.includes(
                  'delete_stockverification',
                ) && (
          <Link>
            <Tooltip title="Delete">
              <Popconfirm
                title="Are you sure you want to Delete this record?"
                onCancel={() => message.info('Action cancelled')}
                okText="Yes"
                cancelText="No"
              >
                <DeleteOutlined style={{ fontSize: '18px' }} />
              </Popconfirm>
            </Tooltip>
          </Link>
                )}
        </Space>
      ),
    },
  ];
  const filteredColumns = columns.filter(column =>
    checkedList.includes(column.key),
  );

  const rowSelection = {
    selectedRowKeys,
    onChange: selectedRowKeys => setSelectedRowKeys(selectedRowKeys),
  };

  useEffect(() => {
    dispatch(
      fetchstocReportList({
        page,
        pagesize,
        ...(search && { search: search }),
        ...(orderBy && { ordering: orderBy }),
      }),
    );
  }, [dispatch, page, pagesize, search, orderBy]);

  const dataSource = Reportdata.map((item, index) => ({
    ...item,
    key: item.id || index,
    SrNo: (page - 1) * pagesize + index + 1, // Calculate Sr. No. based on page and limit
  }));


  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
  };
  const debounceTimeout = useRef(null);

  const handleSearch = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setSearch(value);
    localStorage.setItem('stockVerificationList', value);

  };
  const resetFilter = () => {
    setSearch('');
    setInputValue('');
    setOrderBy(null); // if applicable

    localStorage.removeItem('stockVerificationList');
    dispatch(fetchstocReportList({ page: 1, pagesize }));
  };
  useEffect(() => {
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, []);

  const handlePageChange = newPage => {
    setPage(newPage);
    setOrderBy('');
  };
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';

    if (sortField === 'report_id' && sortOrder === 'ascend') {
      sortingEnumKey = 'report_id';
    }
    if (sortField === 'report_id' && sortOrder === 'descend') {
      sortingEnumKey = '-report_id';
    }
    if (sortField === 'date_time' && sortOrder === 'ascend') {
      sortingEnumKey = 'date_time';
    }
    if (sortField === 'date_time' && sortOrder === 'descend') {
      sortingEnumKey = '-date_time';
    }

    return sortingEnumKey;
  };


  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Checkbox value="SrNo" disabled>
                Sr. No.
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="customer_name">Name</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="email">Email</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="under_group">Under Group</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="account_group">Account Group</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="customer_type">Customer Type</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="delivery_days">Delivery Days</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="udyam_no">Udyam No</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="applicable_gst">Applicable GST</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="customer_section_no">
                Customer Profile No
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="factoryAddress">Factory Address</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="officeAddress">Office Address</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="phone_number">Contact Number</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="gstin_number">GSTIN No</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="gst_type">GST Type</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="pan_number">Pan Number</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="created_at">Created At</Checkbox>
            </Col>

            <Col xs={24} md={12}>
              <Checkbox value="created_by">Created By</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="updated_at">Updated At</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="updated_by">Updated By</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="action" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );
  const handlePageSizeChange = (current, size) => {
    setPage(1); // Reset to first page if needed
    setPageSize(size); // You must have a setter or state update
  };



  return (
   <div className='mainwrap'>
      <div className="sticyaction">
        <div className="sticky-header">
          <Row
            className="pagenamerow mb-0 "
            justify="space-between"
            align="middle"
          >
            <Col>
              <h2 style={{ margin: 0 }}>Stock Verification Report</h2>
              <div className="bredcrumbwrp">
                <Link onClick={(() => { navigate(-1) })} className="back">
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: 'Bundle Verification Report' },
                  ]}
                />
              </div>
            </Col>
            <Col>
              <Space size="small">
                <Input
                  placeholder="Search"
                  className='searchbox'
                  prefix={<SearchOutlined />}
                  value={search}
                  onChange={handleSearch}
                  style={{ width: '100%' }}
                />
                <Tooltip title="Filter">
                  <Button
                    type="primary"
                    disabled={!search && !orderBy}
                    className="iconlink"
                    onClick={resetFilter}
                  >
                    <FilterIcon />
                  </Button>
                </Tooltip>
                <Link to="/add-new-report">
                  <Tooltip title="Add New Customer">
                    <Button type="primary" icon={<PlusOutlined />}>
                      Add New Report
                    </Button>
                  </Tooltip>
                </Link>
              </Space>
            </Col>
          </Row>
        </div>
      </div>
       <div className='tablewrp'>
          <Table

            columns={filteredColumns}
            dataSource={dataSource}
            pagination={false}
            loading={status === 'loading'}
            scroll={{ x: '600px' }}
            onChange={handleTableChange}
          />
        </div>


      
          <Pagination
            current={page}
            pageSize={pagesize}
            total={ReporttotalRecord}
            showSizeChanger
            onShowSizeChange={handlePageSizeChange}
            pageSizeOptions={["20", "50", "100"]}
            showTotal={total => `Total ${total} items`}
            onChange={handlePageChange}
            locale={{ items_per_page: 'Items / Page' }}
          />
        </div>
    
  );
}

export default StockVerificationList;
